import React from 'react'
import { FormattedMessage } from 'react-intl'
import { colors, Text, SVGIcon, type RadiumStyles } from 'ic-snacks'
import styled from '@emotion/styled'
import ButtonBase from 'legacy/components/ButtonBase'

interface EditImageButtonProps {
  hasImage: boolean
}

const EditImageContainer = styled.div<EditImageButtonProps>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${({ hasImage }) => (hasImage ? 'transparent' : colors.WHITE)};
  color: ${({ hasImage }) => (hasImage ? 'transparent' : colors.GRAY_20)};

  &:hover {
    color: ${colors.WHITE};
    background-color: ${colors.GRAY_13};
    opacity: 0.7;
    border: none;
  }
`

const EditImageButton = styled(ButtonBase)`
  color: currentColor;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`

const DeleteImageButton = styled(ButtonBase)`
  color: currentColor;
  &:hover {
    color: ${colors.RED_500};
  }
`

const DELETE_ICON_STYLE: RadiumStyles = {
  position: 'absolute',
  bottom: 0,
  right: 0,
  width: 50,
  height: 50,
  padding: 13,
}

interface Props {
  hasImage: boolean
  onEdit: () => void
  onDelete?: () => void
}

class ImageActionsOverlay extends React.Component<Props> {
  render() {
    const { hasImage, onEdit, onDelete } = this.props

    return (
      <EditImageContainer hasImage={hasImage}>
        <EditImageButton type="button" onClick={onEdit}>
          <SVGIcon
            name="logout"
            style={{
              height: '50px',
              width: '50px',
              transform: 'rotate(-90deg)',
            }}
          />
          <Text
            variant={'T.14'}
            style={{
              marginTop: 20,
              color: 'currentColor',
            }}
          >
            <FormattedMessage
              id={hasImage ? 'catalog.product.image.edit' : 'catalog.product.image.add'}
            />
          </Text>
        </EditImageButton>
        {hasImage && onDelete && (
          <DeleteImageButton onClick={onDelete}>
            <SVGIcon name="delete" style={DELETE_ICON_STYLE} />
          </DeleteImageButton>
        )}
      </EditImageContainer>
    )
  }
}

export default ImageActionsOverlay
